/**
 * Arabic translations for company settings page.
 */

const companySettings = {
  // Page title
  title: 'الإعدادات',
  subtitle: 'إدارة ملف الشركة والتفضيلات',

  // Tabs
  tabs: {
    profile: 'الملف الشخصي',
    notifications: 'الإشعارات',
    display: 'العرض',
  },

  // Profile tab
  profile: {
    heading: 'ملف الشركة',
    description: 'تحديث معلومات شركتك الظاهرة للعملاء',
    // Logo section
    logo: {
      title: 'شعار الشركة',
      dragDrop: 'اسحب وأفلت شعارك هنا، أو انقر للتصفح',
      restrictions: 'PNG أو JPG، بحد أقصى 5 ميجابايت',
      remove: 'إزالة الشعار',
      removeConfirm: 'إزالة شعار الشركة؟',
      removeDescription: 'سيؤدي هذا إلى إزالة الشعار الحالي. يمكنك رفع شعار جديد في أي وقت.',
      uploading: 'جارٍ الرفع...',
    },
    // Form fields
    fields: {
      name: 'اسم الشركة (بالإنجليزية)',
      nameAr: 'اسم الشركة (بالعربية)',
      email: 'البريد الإلكتروني للتواصل',
      phone: 'رقم الهاتف',
      address: 'العنوان',
      description: 'الوصف (بالإنجليزية)',
      descriptionAr: 'الوصف (بالعربية)',
      website: 'الموقع الإلكتروني',
    },
    // Placeholders
    placeholders: {
      name: 'أدخل اسم الشركة',
      nameAr: 'أدخل اسم الشركة بالعربية',
      email: 'contact@company.com',
      phone: '+966 5X XXX XXXX',
      address: 'عنوان الشارع، المدينة',
      description: 'وصف مختصر لشركتك',
      descriptionAr: 'وصف مختصر بالعربية',
      website: 'https://www.example.com',
    },
    // Validation
    validation: {
      nameRequired: 'اسم الشركة مطلوب',
      nameMinLength: 'يجب أن يكون اسم الشركة حرفين على الأقل',
      emailInvalid: 'يرجى إدخال عنوان بريد إلكتروني صالح',
      websiteInvalid: 'يرجى إدخال رابط صالح',
    },
    // Actions
    save: 'حفظ التغييرات',
    saving: 'جارٍ الحفظ...',
    saved: 'تم تحديث الملف الشخصي بنجاح',
    saveError: 'فشل تحديث الملف الشخصي',
  },

  // Notifications tab
  notifications: {
    heading: 'تفضيلات الإشعارات',
    description: 'اختر طريقة إشعارك بنشاط الفريق والعقارات',
    // Sections
    teamActivity: {
      title: 'نشاط الفريق',
      description: 'احصل على إشعارات عند انضمام أو مغادرة أعضاء الفريق أو تغيير أدوارهم',
      email: 'إشعارات البريد الإلكتروني',
      inApp: 'إشعارات داخل التطبيق',
    },
    listingEvents: {
      title: 'أحداث العقارات',
      description: 'احصل على إشعارات حول تغييرات حالة العقارات والاستفسارات',
      email: 'إشعارات البريد الإلكتروني',
      inApp: 'إشعارات داخل التطبيق',
    },
    save: 'حفظ التفضيلات',
    saving: 'جارٍ الحفظ...',
    saved: 'تم تحديث التفضيلات بنجاح',
    saveError: 'فشل تحديث التفضيلات',
  },

  // Display tab
  display: {
    heading: 'تفضيلات العرض',
    description: 'تخصيص مظهر التطبيق',
    language: {
      title: 'اللغة',
      description: 'اختر لغتك المفضلة',
      english: 'English',
      arabic: 'العربية',
    },
    theme: {
      title: 'المظهر',
      description: 'اختر نظام الألوان المفضل',
      light: 'فاتح',
      dark: 'داكن',
      system: 'النظام',
    },
    note: 'يتم حفظ هذه الإعدادات محلياً في متصفحك.',
  },

  // Unsaved changes dialog
  unsavedChanges: {
    title: 'تغييرات غير محفوظة',
    message: 'لديك تغييرات غير محفوظة. هل تريد حفظها قبل المغادرة؟',
    save: 'حفظ',
    discard: 'تجاهل',
    cancel: 'إلغاء',
  },

  // Crop modal
  crop: {
    title: 'اقتصاص الصورة',
    instructions: 'اسحب للتحريك، استخدم التمرير للتكبير',
    cancel: 'إلغاء',
    apply: 'تطبيق',
  },

  // Role permission message
  noPermission: 'فقط مالكي الشركة والمسؤولين يمكنهم تعديل الإعدادات',
};

export default companySettings;
